import { BiCollapseAlt } from 'react-icons/bi';
import './LicenseUnitSelector.css';
import { useUserStore } from '../../contexts/userStore';
import ModalComponent from '../Modal/ModalComponent';
import { UnitsTreeView } from '../UnitsTreeView/UnitsTreeView';
import { useEffect, useMemo, useState } from 'react';
import { joinWithCommaAnd } from '../../utils/string';
import { FiPlusCircle } from 'react-icons/fi';
import { TiPlus } from 'react-icons/ti';

export function LicenseUnitSelector({
   unitId,
   setUnitId,
   unitIds,
   setUnitIds,
   label,
   scopedUnitId,
   disabled,
   singleCheck = true,
   ...props
}) {
   const { condominiums, clientLicenses } = useUserStore();
   const [modalIsOpen, setModalIsOpen] = useState(false);
   const [modalState, setModalState] = useState({
      unitId,
      unitIds
   });

   useEffect(() => {
      setModalState({ unitId });
   }, [unitId]);

   useEffect(() => {
      setModalState({ unitIds });
   }, [unitIds]);

   const [units, unitsWithLicense] = useMemo(() => {
      const unitsToShow = new Map();
      const units = new Map();
      for (const unit of condominiums) {
         if (clientLicenses?.find(clientLicense => clientLicense.id_condominium && Number(clientLicense.id_condominium) === Number(unit.id))) {
            units.set(unit.id, unit);
            unitsToShow.set(unit.id, unit);
            for (const ancestorId of unit.ancestorIds) {
               const ancestor = condominiums.find(condominium => Number(condominium.id) === Number(ancestorId));
               if (ancestor && ancestor.parentId) {
                  unitsToShow.set(ancestor.id, ancestor);
               }
            }
         }
      }
      return [
         Array.from(unitsToShow.values()),
         Array.from(units.values())
      ];
   }, [condominiums]);

   function getLabel() {
      if (singleCheck) {
         return condominiums.find(unit => unit.id === `${unitId}`)?.name;
      } else {
         // calcular tamanho max de caracteres que o bloco consegue renderizar, os que excederem mostrar um badge: Unit 1, Unit2 x mais
         const maxChars = 20;
         const unitsNames = [];
         const hiddenUnitsNames = [];
         for (const unitId of unitIds) {
            const unit = condominiums.find(unit => unit.id === `${unitId}`);
            if (unit && [...unitsNames, unit.name].join(', ').length <= maxChars) {
               unitsNames.push(unit.name);
            } else {
               hiddenUnitsNames.push(unit.name);
            }
         }
         return (
            <>
               {joinWithCommaAnd(unitsNames)}
               {hiddenUnitsNames?.length > 0 && (
                  <span className="inline-flex flex-row items-center gap-1 ml-4! px-2! py-1! rounded-md relative text-(--textColor) text-xs! overflow-hidden">
                     <span className='absolute inset-0 bg-(--textColor) opacity-10'></span>
                     <TiPlus className='relative z-10' />
                     <span className='relative z-10 font-bold!'>{hiddenUnitsNames.length}</span>
                  </span>
               )}
            </>
         );
      }
   }

   return (
      <>
         <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label htmlFor="select-unit-button" style={{ fontSize: '14px', textAlign: 'left', color: 'var(--textColor)', marginBottom: 5 }}>
               {label ?? 'Pertence a'}
            </label>
            <button type='button' id="select-unit-button" disabled={disabled} className='btn-select-unit h-[44px]! box-border! flex-none!' onClick={e => setModalIsOpen(true)}>
               <span>
                  {getLabel()}
               </span>
               <BiCollapseAlt />
            </button>
         </div>
         {
            modalIsOpen && (
               <ModalComponent
                  modalIsOpen={modalIsOpen}
                  modalText={singleCheck ? `Selecione a licença` : `Selecione as licenças`}
                  handleConfirm={() => {
                     if (singleCheck) {
                        setUnitId(modalState.unitId);
                     } else {
                        setUnitIds(modalState.unitIds);
                     }
                     setModalIsOpen(false);
                  }}
                  handleCancel={() => { setModalIsOpen(false); }}
                  hideButtons={false}
               >
                  <div className="modal-levels-selector-content">
                     <UnitsTreeView
                        showRoot={false}
                        unitsArg={units}
                        checkableUnits={unitsWithLicense}
                        scopedUnitId={scopedUnitId}
                        values={[
                           ...(modalState.unitId ? [modalState.unitId] : []),
                           ...(modalState.unitIds ? modalState.unitIds : [])
                        ]}
                        onChange={ids => {
                           setModalState(prev => ({
                              unitId: singleCheck ? ids[0] : prev.unitId,
                              unitIds: !singleCheck ? ids : prev.unitIds
                           }))
                        }}
                        singleCheck={singleCheck}
                     />
                  </div>
               </ModalComponent>
            )
         }
      </>
   );
}